export default  {
  template: require('../views/loading.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/components/loading.component.js